import { ExportResult } from 'pages/Search/models';

export interface SearchExportState {
  export: ExportResult[];
  loading: boolean;
}

export interface FilePrintOptions {
  showReferences: boolean;
  leantsPrintType: 'summary' | 'details';
}

export const SEARCH_EXPORT_CLEAR = 'SEARCH_EXPORT_CLEAR';
export const SEARCH_EXPORT_LOADING = 'SEARCH_EXPORT_LOADING';

interface SearchExportClearAction {
  type: typeof SEARCH_EXPORT_CLEAR;
}

interface SearchExportLoadingAction {
  type: typeof SEARCH_EXPORT_LOADING;
  payload: boolean;
}

export type SearchExportActionTypes =
  | SearchExportClearAction
  | SearchExportLoadingAction;
